import { BASE_URL } from '@/shared/lib/const/env'

const VIDEO_PATTERN = /\.(mp4|avi|webm|ogg|mov)(?:[?#].*)?$/i

export const resolveReviewMediaUrl = (src?: string) => {
	if (!src || /^(https?:|blob:|data:)/i.test(src)) return src
	return `${BASE_URL}${src.startsWith('/') ? '' : '/'}${src}`
}

export const isReviewVideo = (src?: string) => !!src && VIDEO_PATTERN.test(src)
